<template lang="">
  <div>
    <div id="header_content">
      <LeftNav :categoryList="categoryList" />
      <div id="header_content_right">
        <div class="title" v-if="categoryList.length>0">
          {{categoryTitle[0].title}}&nbsp;&nbsp;<span>|&nbsp;&nbsp;建筑装饰系统集成商</span></div>
        <div class="more">
          <router-link to="/home"><img src="@/assets/images/home.jpg"></router-link> &gt; <router-link
            :to="{path:'/about',query:{category_id:categoryList[0].id}}">>走进中磊</router-link> &gt; <a
            v-if="categoryTitle.length>0" href="javascript:;">{{categoryTitle[0].title}}</a>
        </div>
        <div v-if="aboutList.length>0" class="products_header">
          <a @click="selectItem(item.id)" @mouseover="hoverItem = item.id" @mouseout="hoverItem = null"
            v-for="(item,index) in aboutList" :key="index" :class="{ current: isActive(item.id) }">{{item.title}}</a>
        </div>
        <div class="content" style="background:url(/) no-repeat center bottom;">
          <div class="content_content" v-html="detalList.content"></div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import LeftNav from '@/components/leftnav'
  export default {
    components: {
      LeftNav
    },
    data() {
      return {
        hoverItem: null, // 鼠标悬停的项
        selectedItem: null, // 点击选择的项
        categoryList: [],
        categoryTitle: '',
        shouldGetDetail: false,
        aboutList: [],
        detalList: [],
        category_id: 0,
      }
    },
    mounted() {
      this.getCategory();
      // this.getAbout();
      // this.getDetail()
    },
    async created() {
      await this.getAbout();

      if (this.aboutList.length > 0) {
        this.shouldGetDetail = true;
        // 使用aboutList中的第一个元素的id作为getDetail的参数
        await this.getDetail(this.aboutList[0].id);
      }
    },
    watch: {
      '$route.query.category_id'(newValue, oldValue) {
        this.getCategory();
        if (this.shouldGetDetail) {
          this.getAbout().then(() => {
            if (this.aboutList.length > 0) {
              this.getDetail(this.aboutList[0].id);
            }
          });
        }
      }
    },
    methods: {
      async getCategory() {
        const res = await this.$request.post('aboutcategory/getAll', {
        })
        if (res.data.code === 0) {
          this.categoryList = res.data.data
          this.categoryTitle = this.categoryList.filter(item => item.id == this.$route.query.category_id)
        }
      },
      async getAbout() {
        this.category_id = this.$route.query.category_id
        const res = await this.$request.post('about/getAll', {
          category_id: this.category_id
        })
        if (res.data.code === 0) {
          this.aboutList = res.data.data
        }
      },
      async getDetail(cid) {
        let res = await this.$request.post('about/getDetail', {
          id: cid ? cid : 2
        })
        if (res.data.code === 0) {
          this.detalList = res.data.data;
        }
      },
      isActive(id) {
        return this.hoverItem === id || this.selectedItem === id;
      },
      selectItem(id) {
        this.selectedItem = id;
        this.getDetail(id); // 点击时获取详情
      },
    },
  }
</script>
<style lang="css">
  .products_header a {
    cursor: pointer;
  }
</style>